import api from "../../../services/api.service"

/**
 * Appointments — the new calendar module (meetings, calls, onboardings...).
 * Independent from the legacy calendar module. Backend: /appointments/*
 * (see AppointmentController). Permission: "appointments".
 * Enum metadata (types, modes, statuses, colors) lives in
 * @/model/appointment/appointmentEnums.
 */
export const appointmentModule = {
    namespaced: true,
    state: {
        loading: false,
        // assignable users { id, name } cached for owner / attendees pickers
        assignableUsers: [],
    },
    getters: {
        isLoading: (state) => state.loading,
        getAssignableUsers: (state) => state.assignableUsers,
    },
    mutations: {
        setLoading(state, v) {
            state.loading = v;
        },
        setAssignableUsers(state, users) {
            state.assignableUsers = users || [];
        },
    },
    actions: {
        /** Calendar range query. filter: {from, to, userIds, buIds, modes, types, statuses, onlyMine, ...} */
        fetchAll({commit, dispatch}, filter = {}) {
            commit('setLoading', true);
            return api.sendRequest('appointments/get', null, filter).then(
                (ans) => {
                    commit('setLoading', false);
                    return ans['Appointments'] || [];
                },
                (error) => {
                    commit('setLoading', false);
                    return rejectWith(dispatch, error);
                }
            );
        },
        fetchById({dispatch}, id) {
            return api.get('appointments/id/' + id).then(
                (ans) => ans['Appointment'],
                (error) => rejectWith(dispatch, error)
            );
        },
        create({dispatch}, appointment) {
            return api.sendRequest('appointments/add', null, appointment).then(
                (ans) => ans['Appointment'],
                (error) => rejectWith(dispatch, error)
            );
        },
        update({dispatch}, {id, appointment}) {
            return api.sendRequest('appointments/update/' + id, null, appointment).then(
                (ans) => ans['Appointment'],
                (error) => rejectWith(dispatch, error)
            );
        },
        updateStatus({dispatch}, {id, status}) {
            return api.sendRequest('appointments/update/status/' + id, {status}, {}).then(
                (ans) => ans['Appointment'],
                (error) => rejectWith(dispatch, error)
            );
        },
        remove({dispatch}, id) {
            return api.sendRequest('appointments/delete/' + id, null, {}).then(
                (ans) => ans,
                (error) => rejectWith(dispatch, error)
            );
        },
        /** Load org users for the owner / attendees pickers (cached in state). */
        loadAssignableUsers({commit, rootGetters}) {
            return new Promise((resolve) => {
                api.sendRequest('superuser/user/get', {
                    buids: (rootGetters['data/getSelectedBranchesIds'] || []).join(','),
                    amount: 1000,
                    page: 1,
                }, {}).then(
                    (ans) => {
                        let raw = ans && ans['Users'] ? ans['Users'] : [];
                        if (!Array.isArray(raw)) raw = Object.values(raw);
                        const users = raw.map((u) => ({
                            id: u.id,
                            name: ((u.firstname || '') + ' ' + (u.lastname || '')).trim()
                                || u.username || ('#' + u.id),
                        }));
                        commit('setAssignableUsers', users);
                        resolve(users);
                    },
                    () => resolve([])
                );
            });
        },
    }
};

function rejectWith(dispatch, error) {
    dispatch('notifications/error', {
        title: 'Appointments',
        message: (typeof error === 'object' && error.message !== undefined ? error.message : error),
    }, {root: true});
    return Promise.reject(error);
}
